import {
  selectCustomerProfile,
  selectListingsUriForZipcode,
  selectCustomerIsRealEstateAgent
} from '../../../../store/selectors/customerProfile'
import qs from 'qs'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { camelizeKeys } from '../../../../helpers/utils'
import useGoogle from 'react-google-autocomplete/lib/usePlacesAutocompleteService'
import { Avatar, Flex, Icon, LinkButton, Text } from '@homebotapp/hb-react-component-catalog'

export const MSG = defineMessages({
  resourceFrom: {
    id: 'CustomerListingsCard.resourceFrom',
    defaultMessage: 'A resource from, {name}'
  },
  seeListingsFromMySite: {
    id: 'CustomerListingsCard.seeListingsFromMySite',
    defaultMessage: 'See more listings on my site'
  }
})

export const CustomerListingsCard = () => {
  const intl = useIntl()
  const customerProfile = useSelector(selectCustomerProfile) || {}
  const isCustomerREA = useSelector(selectCustomerIsRealEstateAgent)
  const { placesService } = useGoogle({ apiKey: process.env.REACT_APP_GOOGLE_KEY })
  const hasCustomListingsFlagEnabled = customerProfile?.features?.some((feat: string) => feat === 'customListings')
  const queryParams = camelizeKeys(
    qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    })
  )
  const [zipCode, setZipCode] = useState(queryParams?.postalCode)

  useEffect(() => {
    if (queryParams?.postalCode) {
      setZipCode(queryParams.postalCode)
    } else if (queryParams?.placeId) {
      placesService?.getDetails(
        {
          placeId: queryParams.placeId
        },
        placeDetails => {
          const zipCode = placeDetails?.address_components?.find(
            (component: any) => component?.types?.includes('postal_code')
          )

          if (zipCode?.long_name) {
            return setZipCode(zipCode.long_name)
          }
        }
      )
    } else {
      // TODO: get zipcode from map center via geocoding
    }
  }, [queryParams])

  const customListingsUri = useSelector(selectListingsUriForZipcode(zipCode))

  if (!customListingsUri || !isCustomerREA || !hasCustomListingsFlagEnabled) {
    return null
  }

  return (
    <Flex
      alignItems='center'
      backgroundColor='neutral.50'
      borderWidth={0.5}
      borderColor='neutral.300'
      borderRadius='16px'
      p='12px 10px'
      gap='12px'
      m={2}
      mt={4}
    >
      <Avatar size='sm' src={customerProfile?.photoUri} />

      <Flex flexDirection={['column', 'row']} justifyContent={['flex-start', 'space-between']} flex={1}>
        <Text as='span' textTransform='uppercase' m={0} size='2xs' fontWeight='bold'>
          {intl.formatMessage(MSG.resourceFrom, { name: `${customerProfile?.firstName} ${customerProfile?.lastName}` })}
        </Text>
        <LinkButton size='xs' rightIcon={<Icon name='external-link' />} href={customListingsUri} target='_blank'>
          {intl.formatMessage(MSG.seeListingsFromMySite)}
        </LinkButton>
      </Flex>
    </Flex>
  )
}
